<script>
import _ from 'lodash';
import { VCheckbox } from 'vuetify/lib';
import BReadOnlyTextField from './BReadOnlyTextField';
import ValidationField from '@/components/base_components/ValidationField';

function getInputValueString(inputValue) {
  return inputValue === true ? 'Ja' : inputValue === false ? 'Nein' : '';
}

export default {
  functional: true,
  model: VCheckbox.options.model,
  props: {
    readOnly: { type: Boolean, default: false },
    option: Boolean,
    uuid: String,
    propPath: String,
    formRef: String,
    ...VCheckbox.options.props
  },
  render(createElement, context) {
    if (!context.props.readOnly) {
      const customData = {
        class: [
          'b-checkbox--input',
          { 'b-checkbox--option': context.props.option }
        ],
        props: {
          hideDetails: 'auto',
          type: 'checkbox',
          color: 'green'
        },
      };

      context.data.props = context.props;
      _.mergeWith(context.data, customData, function(objValue, srcValue) {
        if (_.isArray(objValue)) return objValue.concat(srcValue);
      });

      const slots = Object.entries(context.slots).map(([slot, value]) =>
        createElement('template', { slot }, value)
      );

      const slot = ({ error, deleteServerError }) => {
        const data = {
          ...context.data,
          props: {
            ...context.data.props,
            errorMessages: error,
          },
          on: {
            ...context.data.on,
            change: () => deleteServerError(),
            input: () => deleteServerError(),
          }
        }

        return createElement(VCheckbox, data, slots);
      };

      return createElement(ValidationField, {
        props: {
          uuid: context.props.uuid,
          propPath: context.props.propPath,
          formRef: context.props.formRef
        },
        scopedSlots: { default: slot }
      });
    } else {
      const customProps = {
        label: context.props.label,
        value: getInputValueString(context.props.inputValue)
      };
      return createElement(BReadOnlyTextField, { props: customProps });
    }
  }
};
</script>

<style lang="scss">
.b-checkbox {
  &--input {
    margin-top: 0px;
    padding-top: 0px;
    .v-input__control .v-input__slot {
      align-items: start;
    }
  }
}
</style>
